
import api from './api';
import brand from './brand';
import session from './session';
import storage from './storage';

class User {

	constructor (Api, Session, Storage) {
		this.Api = Api;
		this.Session = Session;
		this.Storage = Storage;
	}

	get () {
		return this.Session.get('user');
	}

	isWorker () {
		return !!this.Session.get('worker');
	}

	isLoggedIn () {
		return !!this.get();
	}

	requireLogin () {
		var token      = getUrlParameter('token');
		var brandId    = getUrlParameter('brand_id');
		var marketerId = getUrlParameter('marketer_id');

		// Auto-login using worker token
		if (token && brandId && marketerId) {
			return this.Api.post({
				url: 'v1.1/m/auth/login/worker',
				body: {
					token:       token,
					brand_id:    brandId,
					marketer_id: marketerId,
				},
			}).then(response => {
				this.Session.set('worker',      true);
				this.Session.set('user',        response.marketer);
				this.Session.set('brandObject', response.brand);
				this.Session.set('brand',       response.brand.name);
				return true;
			});
		}

		// Regular user behavior
		if (!this.isLoggedIn()) {
			return Promise.reject();
		}

		return Promise.resolve();
	}

	login (brand, email, password) {
		this.setCredentials(brand, email);
		return this.Api.post({
			url:  'v1.1/m/auth/login',
			body: {
				email,
				password,
				brand_name: brand
			}
		}).then(response => {
			this.Session.set('worker', false);
			this.Session.set('user', response.marketer);
			this.Session.set('brandObject', response.brand);
			this.Session.set('brand', brand);
			return response.marketer;
		});
	}

	resetPassword (brand, email) {
		return this.Api.post({
			url:  'v1.1/m/auth/reset/password',
			body: {
				email,
				brand_name: brand
			}
		});
	}

	logout () {
		this.Session.unset('user');
		this.Session.unset('brand');
		this.Session.unset('brandObject');
		return Promise.resolve();
	}

	getCredentials () {
		try {
			return Promise.resolve({
				brand: this.Storage.get('brand') || '',
				email: this.Storage.get('email') || '',
			});
		} catch (ex) {
			return Promise.resolve({
				brand: '',
				email: '',
			});
		}
	}

	setCredentials (brand, email) {
		try {
			this.Storage.set('brand', brand || '');
			this.Storage.set('email', email || '');
		} catch (ex) {
			// do nothing...
		}
		return this.getCredentials();
	}

}

User.$inject = ['Api', 'Session', 'Storage'];

export default angular.module('service.user', [api, brand, session, storage])
	.service('User', User)
	.name;

/*
 * Helpers
 */
function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}



// WEBPACK FOOTER //
// ./src/service/user.js